export const adminCommunity = {
  // Community Genealogy Tree Admin Page
  "admin.community.communityGenealogyTree.title": "Albero Genealogico della Comunità",
  "admin.community.communityGenealogyTree.subtitle": "Visualizza ed esplora la struttura completa dei referral",
  "admin.community.communityGenealogyTree.loading": "Caricamento albero genealogico...",
  "admin.community.communityGenealogyTree.error": "Errore nel caricamento dell'albero genealogico",
  "admin.community.communityGenealogyTree.searchLabel": "Cerca per nome utente",
  "admin.community.communityGenealogyTree.searchPlaceholder": "Inserisci nome utente...",
  "admin.community.communityGenealogyTree.searchButton": "Carica Albero",
  "admin.community.communityGenealogyTree.resetButton": "Reimposta Vista",
  "admin.community.communityGenealogyTree.userNotFound": "Utente non trovato",
  "admin.community.communityGenealogyTree.searchError": "Errore nella ricerca dell'utente",
  "admin.community.communityGenealogyTree.invalidUser": "Utente non valido specificato",
  
  // Tree Node Actions
  "admin.community.treeNode.expand": "Espandi",
  "admin.community.treeNode.collapse": "Comprimi",
  "admin.community.treeNode.directReferrals": "Referral Diretti",
  "admin.community.treeNode.loading": "Caricamento...",
  
  // Error Messages
  "admin.community.errors.accessDenied": "Accesso negato: permessi insufficienti",
  "admin.community.errors.userNotFound": "Utente non trovato",
  "admin.community.errors.networkError": "Ricarica Pagina",
  "admin.community.errors.unexpectedError": "Si è verificato un errore imprevisto"
};